import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { Handshake, Trash2 } from "lucide-react";

const sel = "h-9 rounded border border-slate-700 bg-slate-800 px-2 text-sm text-slate-100";

function IlPick({ value, onChange, iller, tid }) {
  return (
    <div className="flex flex-wrap items-center gap-1">
      {value.map((x) => <span key={x} className="rounded bg-sky-900/50 px-1.5 py-0.5 text-[11px] text-sky-200">{x} <button onClick={() => onChange(value.filter((y) => y !== x))}>×</button></span>)}
      <select data-testid={tid} value="" onChange={(e) => e.target.value && onChange([...new Set([...value, e.target.value])])} className={`${sel} h-7 text-xs`}>
        <option value="">+ İL EKLE</option>{iller.map((i) => <option key={i}>{i}</option>)}
      </select>
    </div>
  );
}

export default function PartnershipsPanel({ firms }) {
  const [list, setList] = useState([]);
  const [iller, setIller] = useState([]);
  const [f, setF] = useState({ a: "", b: "", a_iller: [], b_iller: [] });
  const load = useCallback(() => api.get("/partnerships").then((r) => setList(r.data)), []);
  useEffect(() => { load(); api.get("/geo/provinces", { silent: true }).then((r) => setIller(r.data)); }, [load]);
  const save = async () => {
    try { await api.post("/partnerships", { data: f }); toast.success("ORTAKLIK KAYDEDİLDİ"); setF({ a: "", b: "", a_iller: [], b_iller: [] }); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "HATA"); }
  };
  const name = (id) => (firms.find((x) => x.id === id) || {}).name || id;
  return (
    <div data-testid="partnerships-panel" className="rounded-xl border border-slate-800 bg-slate-900 p-4">
      <p className="mb-1 flex items-center gap-2 text-sm font-semibold text-slate-300"><Handshake className="h-4 w-4 text-emerald-400" /> İKİLİ ORTAKLIKLAR (ESKİ — YENİLER İÇİN GRUP KULLANIN)</p>
      <p className="mb-3 text-[11px] text-slate-500">BİR KERE AYARLANIR. FİRMA A, FİRMA B'NİN HİZMET İLLERİNE KARGO KESİNCE KARGO B'NİN "BANA GELEN KARGOLAR" EKRANINA DÜŞER (VE TERSİ). MÜŞTERİ LİSTESİ, KASA, İÇ HESAPLAR PAYLAŞILMAZ.</p>
      <div className="grid gap-2 md:grid-cols-2">
        <div className="space-y-1 rounded border border-slate-800 p-2">
          <select data-testid="ps-a" value={f.a} onChange={(e) => setF((o) => ({ ...o, a: e.target.value }))} className={`${sel} w-full`}><option value="">FİRMA A SEÇ</option>{firms.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}</select>
          <div className="text-[11px] text-slate-400">A'NIN HİZMET VERDİĞİ İLLER</div>
          <IlPick tid="ps-a-il" value={f.a_iller} iller={iller} onChange={(v) => setF((o) => ({ ...o, a_iller: v }))} />
        </div>
        <div className="space-y-1 rounded border border-slate-800 p-2">
          <select data-testid="ps-b" value={f.b} onChange={(e) => setF((o) => ({ ...o, b: e.target.value }))} className={`${sel} w-full`}><option value="">FİRMA B SEÇ</option>{firms.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}</select>
          <div className="text-[11px] text-slate-400">B'NİN HİZMET VERDİĞİ İLLER</div>
          <IlPick tid="ps-b-il" value={f.b_iller} iller={iller} onChange={(v) => setF((o) => ({ ...o, b_iller: v }))} />
        </div>
      </div>
      <Button data-testid="ps-save" onClick={save} className="mt-2 bg-emerald-600 text-white hover:bg-emerald-700">ORTAKLIĞI KAYDET</Button>
      <div className="mt-3 space-y-1">
        {list.map((p) => (
          <div key={p.id} data-testid={`ps-row-${p.id}`} className="flex flex-wrap items-center gap-2 rounded border border-slate-800 px-2 py-1 text-xs text-slate-300">
            <b className="text-white">{p.a_name || name(p.a)}</b> ({p.a_iller.join(", ") || "—"}) ⇄ <b className="text-white">{p.b_name || name(p.b)}</b> ({p.b_iller.join(", ") || "—"})
            <button data-testid={`ps-edit-${p.id}`} onClick={() => setF({ a: p.a, b: p.b, a_iller: p.a_iller, b_iller: p.b_iller })} className="ml-auto text-sky-400">DÜZENLE</button>
            <button data-testid={`ps-del-${p.id}`} onClick={async () => { await api.delete(`/partnerships/${p.id}`); load(); }} className="text-slate-500 hover:text-rose-400"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
